export default {
      id: "upload-usage",
      viewBox: "0 0 15 16",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#upload",
      toString: function () {
        return this.url;
      }
    }